import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
var classPrefix = "adm-space";
var defaultProps = {
  direction: 'horizontal'
};
export var Space = function Space(p) {
  var _classNames;

  var props = mergeProps(defaultProps, p);
  var direction = props.direction,
      onClick = props.onClick;
  return withNativeProps(props, React.createElement("div", {
    className: classNames(classPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-wrap"), props.wrap), _defineProperty(_classNames, "".concat(classPrefix, "-block"), props.block), _defineProperty(_classNames, "".concat(classPrefix, "-").concat(direction), true), _defineProperty(_classNames, "".concat(classPrefix, "-align-").concat(props.align), !!props.align), _defineProperty(_classNames, "".concat(classPrefix, "-justify-").concat(props.justify), !!props.justify), _classNames)),
    onClick: onClick
  }, React.Children.map(props.children, function (child) {
    return child !== null && child !== undefined && React.createElement("div", {
      className: "".concat(classPrefix, "-item")
    }, child);
  })));
};